// extracted by mini-css-extract-plugin
export default {"sso-outer-container":"social-login_component_sso-outer-container__2KUi9","sso-inner-container":"social-login_component_sso-inner-container__knQS2"};